import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
    createStyles({
        /* Styles applied to the root element. */
        root: {
            alignItems: 'center',
            backgroundColor: theme.palette.background.default,
            borderColor: theme.palette.grey[400],
            borderStyle: 'solid',
            borderWidth: 1,
            boxSizing: 'border-box',
            color: theme.palette.text.secondary,
            display: 'flex',
            fontSize: 16,
            justifyContent: 'center',
            maxHeight: 48,
            minWidth: 48,
            overflow: 'hidden',
            textAlign: 'center',
            whiteSpace: 'nowrap',
        },
        /* Styles applied to the root element if `disableGutters={false}`. */
        gutters: {
            paddingLeft: 16,
            paddingRight: 16,
            '&$marginDense': {
                paddingLeft: 13,
                paddingRight: 13,
            },
        },
        /* Styles applied to the root element if `disablePointerEvents=true`. */
        disablePointerEvents: {
            pointerEvents: 'none',
        },
        /* Styles applied to the root element if `position="start"`. */
        positionStart: {
            borderRightWidth: 0,
            borderBottomLeftRadius: 6,
            borderTopLeftRadius: 6,
        },
        /* Styles applied to the root element if `position="end"`. */
        positionEnd: {
            borderLeftWidth: 0,
            borderBottomRightRadius: 6,
            borderTopRightRadius: 6,
        },
        /* Styles applied to the root element if `margin="dense"`. */
        marginDense: {
            paddingBottom: 0,
            paddingTop: 0,
            marginTop: 8,
            marginBottom: 4,
            height: 32,
        },
        /* Styles applied to the root element if `variant="text"`. */
        variantText: {
            '&$positionStart button': {
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
            },
            '&$positionEnd button': {
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
            },
        },
        /* Styles applied to the root element if `variant="search"`. */
        variantSearch: {
            backgroundColor: 'inherit',
            borderWidth: 0,
            paddingLeft: 0,
            paddingRight: 0,
            minWidth: 88,
            '&$positionStart button': {
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
            },
            '&$positionEnd button': {
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
            },
        },
        /* Styles applied to the root element if `variant="number"`. */
        variantNumber: {
            backgroundColor: 'inherit',
            borderWidth: 0,
        },
    });

export default makeStyles(styles, { name: 'MuiOutlinedAddon' });
